import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Card, Col, Row, Form, Button } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import API from "../../services/axiosInstance";
import Select, { components } from "react-select";

const EditDemandPartnerSetting = () => {
    const { gamId: id } = useParams();
    const [defaultValues, setDefaultValues] = useState([]);
    const [selectedAdunits, setSelectedAdunits] = useState([]);
    const [excludedAdUnitList, setExcludedAdUnitList] = useState([]);

    const allRealOptions = excludedAdUnitList.filter((opt) => opt.value !== "");
    const isAllSelected = selectedAdunits.length === allRealOptions.length;

    const navigate = useNavigate();


    const { handleSubmit, register, control, watch, reset, formState: { errors } } = useForm({ defaultValues });

    const gamSettingData = async () => {
        try {
            const gamSettingRes = await API.get(`/publisher/gam/setting/edit/${id}`);
            const data = gamSettingRes?.data?.data;
            const values = JSON.parse(data?.adUnitList);
            // console.log(values instanceof Array);

            let a = [];
            values.forEach(element => {
                a.push({ label: element, value: element })
            });

            // console.log(a);

            setSelectedAdunits(a);
            // setValue("excludedAdUnitList",values);

            setDefaultValues({
                pubId: data?.pubId,
                payoutPerc: data?.payoutPerc,
                gamAccountId: data?.gamAccountId,
                domain: data?.domain,
                pubName: data?.pubName,
                adUnitList: data?.adUnitList,
                extraAdUnit: data?.extraAdUnit,
                extraInclusionAdUnit: data?.extraInclusionAdUnit
            })

        } catch (error) {
            console.error("API Error:", errors);
        }

    }

    // excluded Ad unit lists
    const excludedLists = async () => {
        try {
            const resp = await API.get(`/publisher/gam/setting/exclusion/adunits/${id}`);
            if (resp.status == 200) {
                // const options = Object.values(excludedAdUnitList);
                const data = resp?.data?.data;
                setExcludedAdUnitList(data);


            }
        } catch (error) {
            console.error("API error: ", error)
        }
    }


    const onSubmit = async (data) => {
        const payload = {
            pubId: data?.pubId,
            // pubName:data?.pubName,
            // payoutPerc:data?.payoutPerc,
            gamAccountId: data?.gamAccountId,
            domain: data?.domain,
            adUnitList:
                typeof data?.adUnitList === "string"
                    ? data.adUnitList
                    : JSON.stringify(data?.adUnitList),
            extraAdUnit: data?.extraAdUnit,
            extraInclusionAdUnit: data?.extraInclusionAdUnit
        }
        // console.log(payload);

        try {
            const response = await API.put("/publisher/gam/setting/update", payload);
            if (response?.data?.status === "Success") {
                alert(response?.data?.message)
                reset();
                navigate(`/gamsetting`)
            } else {
                alert(response?.data?.message || "Failed");
            }
        } catch (error) {
            console.error("API Error:", errors);
            alert(errors?.response?.data?.message || "Something went wrong!");
        }
        // console.log(data);

    }


    useEffect(() => {
        gamSettingData();
        excludedLists();
        // Promise.all(gamSettingData());
    }, []);
    // console.log(excludedAdUnitList);

    useEffect(() => {
        if (defaultValues) {
            reset(defaultValues);
        }
    }, [defaultValues]);

    return (
        <>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <span>Tech Admin</span>
                <Link to={'/gamsetting'}><span>Demand Partner 1 Setting</span></Link>
                <span>{watch("domain")}</span>
                <span>Update</span>
                {/* <span>{id}</span> */}
                
            </div>
            <Card className="p-3 instreamRows">
                <h6 className="title mb-5">Gam Setting Form</h6>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Card className="p-3 form-group row">
                        <Row>
                            <Col md={3}>
                                <label>Publisher <span className="text-danger"></span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Group>
                                    <Form.Label value={defaultValues?.pubName} {...register("pubName")}>{defaultValues?.pubName}</Form.Label>
                                </Form.Group>
                                {/* <label {...register("pubName",value=defaultValues?.pubName)}>{defaultValues?.pubName}<span className="text-danger"></span> </label> */}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Domain <span className="text-danger"></span> </label>
                            </Col>
                            <Col md={5}>
                                <label>{defaultValues?.domain}<span className="text-danger"></span> </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Excluded Ad Unit * <span className="text-danger"></span> </label>
                            </Col>
                            <Col md={5}>
                                <Controller
                                    name="adUnitList"
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={excludedAdUnitList}
                                            // value={selectedAdunits}
                                            // onChange={handleChange}
                                            value={excludedAdUnitList.filter(opt =>
                                                field.value?.includes(opt.value)
                                            )}
                                            onChange={(selected) =>
                                                field.onChange(selected ? selected.map(x => x.value) : [])
                                            }
                                            isMulti
                                            closeMenuOnSelect={false}
                                            // {...register("adUnitList")}
                                            placeholder="None"
                                            styles={{
                                                control: (base) => ({ ...base, minHeight: 36 }),
                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                            }}

                                            components={{
                                                // Inlining MenuList so there's only one return in the file:
                                                MenuList: (props) => (
                                                    <div>
                                                        <div
                                                            style={{
                                                                padding: "8px",
                                                                borderBottom: "1px solid #ccc",
                                                                display: "flex",
                                                                justifyContent: "flex-start",
                                                            }}
                                                        >
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    props.selectProps.onChange(
                                                                        isAllSelected ? [] : allRealOptions
                                                                    );
                                                                }}
                                                                className="buttonAll"
                                                                style={{
                                                                    border: "1px solid #0000003d",
                                                                    fontSize: "14px",
                                                                    borderRadius: "2px",
                                                                }}
                                                            >
                                                                {isAllSelected ? "✖ Deselect All" : "✔ Select All"}
                                                            </button>
                                                        </div>
                                                        <components.MenuList {...props}>
                                                            {props.children}
                                                        </components.MenuList>
                                                    </div>
                                                ),
                                            }}
                                        />
                                    )}
                                />

                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Additional Exclusion Ad Unit <span className="text-danger"></span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    {...register("extraAdUnit")}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Additional Inclusion Ad Unit <span className="text-danger"></span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    {...register("extraInclusionAdUnit")}
                                />
                            </Col>
                        </Row>
                    </Card>
                    <Button type="submit" variant="primary" className="mt-3 submitBtn">{"Submit"}</Button>
                </Form>

            </Card>

        </>
    )
}

export default EditDemandPartnerSetting;